import React, { useState } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { Modal } from 'antd';
import { parse as twParse } from 'twemoji-parser';
import { textMsgParser, xss, breakSvg, getWidAndHei } from '@laigu/utils';
import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';
import filterBlackList from '@laigu/utils/filterBlackList';
import ImagePlacholder, { corpUrl, isAliUrl } from './ImagePlacholder';

// Vite 不支持 require()，用 import.meta.glob 预加载所有 emoji SVG
const emojiSvgModules = import.meta.glob('./components/img/emoji/*.svg', { eager: true, query: '?url', import: 'default' });
const getEmojiSvgUrl = val => emojiSvgModules[`./components/img/emoji/${val}.svg`];

import ImageViewer from './../image-viewer';

import style from './index.less';

const { emojiParser } = textMsgParser;

const Rich = props => {
  const [viewerVisible, setViewerVisible] = useState(false);

  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const { src } = props;

  let loadTimer;

  /*
   * 默认宽高 320 * 500
   * 由于现在富文本里面的图片还是上传到s3上面
   * 暂时兼容设置定高
   */
  let width1 = 320;
  let height1 = 500;

  const localUrl = corpUrl(src);

  let imgObject = new Image();

  imgObject.src = localUrl;

  imgObject.onLoad = onImgLoaded();

  function onImgLoaded() {
    if (loadTimer !== null) clearTimeout(loadTimer);
    if (!imgObject.complete) {
      loadTimer = setTimeout(function() {
        onImgLoaded();
      }, 3);
    } else {
    }
  }

  let width11 = imgObject.width;
  let height11 = imgObject.height;

  if (!width1 && !height1) {
    width1 = getWidAndHei(width11, height11)[0];
    height1 = getWidAndHei(width11, height11)[1];
  }

  return (
    <>
      {!isImageLoaded && <ImagePlacholder height={height1} width={width1} />}
      <img
        alt=''
        style={{
          maxHeight: isAliUrl(src) ? height1 : 'auto',
          maxWidth: isAliUrl(src) ? 'auto' : width1,
          height: isAliUrl(src) ? 'auto' : height1,
          display: isImageLoaded ? 'inline-block' : 'none'
        }}
        src={src}
        onLoad={() => {
          setIsImageLoaded(true);
        }}
        onClick={() => {
          setViewerVisible(true);
        }}
        onError={e => {
          e.target.src = breakSvg;
        }}
      />

      <ImageViewer
        data={{
          imageList: [{ src, alt: '' }],
          viewerVisible
        }}
        setViewerVisible={setViewerVisible}
      />
    </>
  );
};
// 防注入类似 /auth/callback?agent_id=1608689&ent_id=265857&token=bdb926019013a6c4dbaf51aadae3f81658c5258491449b0ea7a2db202a0f41de&callback=1&a=standalone.html 导出登录信息失效
const exceptUrl = ['/auth/callback'];

const MessageRich = props => {
  const { data = '', onLoad } = props;
  let html = '';
  // 防止注入js
  let safeData = data ? data.replace(/position:\s*fixed/g, '') : data;

  html = xss(safeData);

  try {
    html = emojiParser(html);
    const entities = twParse(html, { buildUrl: val => getEmojiSvgUrl(val) });
    if (entities) {
      entities.forEach(value => {
        const re = new RegExp(`${value.text}`);
        if (value.url) {
          html = html.replace(re, `<span class='base_wrap'><img src=${value.url} /></span>`);
        }
      });
    }
  } catch (e) {}

  const handleClick = url => {
    // 历史消息服务域名保持原有打开方式
    if (!/(meiqiayun\.com|meiqia\.com|mstatik\.com|meiqia\.cn)/.test(url) || !/^http[s]?:/.test(url)) {
      Modal.confirm({
        title: '安全提示',
        content: '您要访问的内容非本站提供，可能有安全风险导致账号被盗或数据泄漏，请确定是否继续前往？',
        maskClosable: true,
        okText: '继续',
        cancelText: '关闭',
        onOk: () => {
          window.open(url);
        }
      });
    } else {
      window.open(url);
    }
  };

  const options = {
    replace: res => {
      const { name, attribs, children } = res;
      if (name === 'img') {
        const {
          attribs: { src }
        } = res;
        if (exceptUrl.includes(src)) {
          return '';
        }
        return <Rich src={src} onLoad={onLoad} />;
      }

      if (attribs && children) {
        if (attribs.class === 'base_wrap') {
          return <span className={style.base_wrap}>{domToReact(children)}</span>;
        }
        if (attribs.href) {
          return (
            <a
              className={style.link}
              onClick={() => {
                handleClick(filterBlackList(removeHTMLScript(attribs.href)));
              }}
            >
              {domToReact(children)}
            </a>
          );
        }
      }
      return res;
    }
  };

  try {
    return <div className={style.richWrapper}>{parse(html, options)}</div>;
  } catch (e) {
    return '';
  }
};

export default MessageRich;
